import { defineNuxtPlugin } from "#app";
import { useGlobalAlertStore } from "../store/global-alert.mjs";
export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      alert: useGlobalAlertStore(nuxtApp.$pinia).showAlert,
      confirm: useGlobalAlertStore(nuxtApp.$pinia).showConfirm
    }
  };
});
